export const errorCodes = {
  duplicateEmail: 'DUPLICATED_EMAIL',
  duplicateEmailCust: 'USER_ALREADY_REGISTERED',
  duplicateIdCust: 'CUSTOMER_ALREADY_PRESENT_WITH_CUSTOMER_ID',
  duplicateUser: 'USER_ALREADY_REGISTERED',
};
